import { render, staticRenderFns } from "./SelectSearchClient.vue?vue&type=template&id=0bd0c980&"
import script from "./SelectSearchClient.vue?vue&type=script&lang=ts&"
export * from "./SelectSearchClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QIcon,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QSelect,QIcon,QItem,QItemSection,QItemLabel}, component.options.components || {})
